module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0007#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0008#abbrs"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0009#ch00"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("0.")]), _vm._v("  Introduction: “He Is Still Out There”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0010#ch01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.")]), _vm._v("  What Came Before Zero?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0011#ch02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.")]), _vm._v("  The Cluster Study")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0012#ch03"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.")]), _vm._v("  “Humanizing This Disease”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0013#ch04"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.")]), _vm._v("  Giving a Face to the Epidemic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0014#ch05"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.")]), _vm._v("  Ghosts and Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0015#ch06"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6.")]), _vm._v("  Locating Gaétan Dugas’s Views")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0016#epil"
    }
  }, [_vm._v("Epilogue: Zero Hour—Making Histories of the North American AIDS Epidemic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0017#app"
    }
  }, [_vm._v("Appendix: Oral History Interviews")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0018#biblio"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0019#index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chimckay0020#fn_notes"
    }
  }, [_vm._v("Footnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77751224","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-mckay-0006.vue
// module id = 69
// module chunks = 0